import Routes from "./router";

export const Pages = () => {
  return <>{Routes.useRenderRoutes()}</>;
};
